import { apiGetList } from './ApiBaseActions';
export const API_GET_LIST_PROFFIT_SEARCH_SHARE_RECEIVE_HEADER = 'API_GET_LIST_PROFFIT_SEARCH_SHARE_RECEIVE_HEADER';
export const API_GET_LIST_PROFFIT_SEARCH_SHARE_RECEIVE_HEADER_SUCCESS = 'API_GET_LIST_PROFFIT_SEARCH_SHARE_RECEIVE_HEADER_SUCCESS';
export const UPDATE_PROFFIT_SEARCH_SHARE_RECEIVE_HEADER_READ_AT = 'UPDATE_PROFFIT_SEARCH_SHARE_RECEIVE_HEADER_READ_AT';
/**
 * 受領履歴の取得（ヘッダー用）
 * @param data
 * @param meta
 * @returns {{payload: {params: *}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: *}, type: *}}
 */
export const apiGetListProffitSearchShareReceiveHeader = (data = {}, meta = {}) => apiGetList(API_GET_LIST_PROFFIT_SEARCH_SHARE_RECEIVE_HEADER, '/proffit_search/slide/receive', Object.assign({ sort: 'unread' }, data), meta);
/**
 * 受領履歴を既読に更新（ヘッダー用）
 * @param id
 * @returns {{payload: {id}, type: string}}
 */
export const updateProffitSearchShareReceiveHeaderReadAt = (id) => ({
    payload: { id },
    type: UPDATE_PROFFIT_SEARCH_SHARE_RECEIVE_HEADER_READ_AT,
});
